import * as React from "react";
import type { SVGProps } from "react";
const SvgBarChart02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.2 19.2v-2.4M12 19.2v-8.4m-7.2 8.4V4.8"
    />
  </svg>
);
export default SvgBarChart02;
